
<template>
  <!--里程碑模块-->
  <div class="milestone_box">
    <div class="milestone">
      <!-- 导航箭头 -->
<!--      <div class="milestone_arrow left"></div>-->
<!--      <div class="milestone_arrow right"></div>-->

      <!-- 山脉背景 -->
      <div class="milestone_mountain"></div>

      <!-- 时间节点 (2009-2026) -->
      <div class="milestone_white2009" data-tooltip="2009-2015年：台球俱乐部运营">
        2009
      </div>

      <div class="milestone_white2016" data-tooltip="2016年：启动璟点台球器材超市全国连锁项目
璟点首家连锁器材店落户山西太原">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2016
      </div>

      <div class="milestone_white2017" data-tooltip="2017年：启动“黄金十年”计划
中国区全权代理环球品牌
璟点全国器材连锁店突破50家">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2017
      </div>

      <div class="milestone_white2018" data-tooltip="2018年：中国区全权代理美洲豹、达芬尼品牌
启动京东、天猫旗舰店
线上合作伙伴达100家">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2018
      </div>

      <div class="milestone_white2019" data-tooltip="2019年：启用秦皇岛山海关办公区
璟点台球杆产品正式投产">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2019
      </div>

      <div class="milestone_white2020" data-tooltip="2020年：正式生产销售璟点品牌台球桌
璟点碳纤维复合材料产品正式投产
协助孵化小怪兽品牌
推出璟点全国级别系列赛事
成立北京新璟体育传媒有限公司">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2020
      </div>

      <div class="milestone_white2021" data-tooltip="2021年：成立葫芦岛客满台科技有限公司">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2021
      </div>

      <div class="milestone_white2022" data-tooltip="2022年：璟点集团正式成立，进入“第二个五年计划”
辽宁东戴河璟点集团台球产业园落地
复合材料、台球杆、台球桌三家自有工厂全面迁入璟点集团台球产业园">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2022
      </div>

      <div class="milestone_white2023" data-tooltip="2023年：璟点集团台球产业园扩建至8万余平方米
与中国台球协会合作，打造“中式台球中国公开赛”职业赛事IP
全国璟点台球器材体验店及特约经销商超200家">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2023
      </div>

      <div class="milestone_white2024" data-tooltip="2024年：四川璟点品牌管理有限公司挂牌成立
成功举办第一届冠军百万中式台球中国公开赛总决赛
璟点品牌入选央视“国潮臻品馆”上榜品牌
璟点台球桌及台球器材远销海外">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2024
      </div>

      <div class="milestone_white2025" data-tooltip="2025年：成功举办第二届冠军百万中式台球中国公开赛总决赛
璟点集团台球产业园扩建
推出全新美洲豹台球桌
毒药台球杆品牌全新上市
璟点星途台球学院落户东戴河">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2025
      </div>

      <!-- 未来模块 -->
<!--      <div class="milestone_future">-->
<!--        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />-->
<!--        美好前璟 <br/>点亮热爱-->
<!--      </div>-->

      <!-- 其他固定元素 -->
      <div class="milestone_2024" data-tooltip="2026年：连续举办两届璟点青少年华彩十六球星途联赛
自主打造“大学生百城联赛”赛事IP
北京、天津璟点台球器材体验中心启用">2026</div>
      <div class="milestone_straight"></div>
      <div class="milestone_JingDian">璟点台球集团 全面启动全球化征程</div>
    </div>
  </div>
</template>

<script>

import '@/assets/css/milestone.css';
export default {
  name: 'Milestone'
}
</script>

<style lang="scss" scoped>

</style>
